import * as Yup from 'yup'

export const isinRatingValidationSchema = Yup.object().shape({
  startDate: Yup.date().required(),
  short: Yup.string().required(),
  long: Yup.string().required(),
})
